import React from "react";

import { Inventory2, Save } from "@mui/icons-material";
import { IconButton, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import Service from "../../util/Service";
import { useNavigate } from "react-router-dom";

const packageRegex = /^(?:[a-z_][a-z0-9_]*\.)*[a-z_][a-z0-9_]*$/i;
const reservedKeywords = new Set([
    "abstract", "assert", "boolean", "break", "...", "while", "void", "volatile", "int", "float", "boolean"]);

export default function PacoteComp(props) {
    const {classeName, pack, action, label, style, variant, children} = props;
    const navigate = useNavigate();
    
    const [pacote, setPacote] = React.useState();
    const [editado, setEditado] = React.useState(false);
    const [msg, setMsg] = React.useState('');

    React.useEffect(()=>{
        if( !pacote){
            setPacote(pack);
        }
    },[pack]);

    function handleChangePacote(e){
        setPacote(e.target.value);        
        setEditado( true);
        setMsg('');
    }
    
    function handleSalvaPacote(){
        console.log( pacote );
        let pacoteSemClass =pacote;
        if( pacoteSemClass.indexOf(classeName > 0)){
            pacoteSemClass = pacote.replace("."+classeName, "");
        }
        console.log( pacoteSemClass );

        if( isValidJavaPackageName(pacoteSemClass)){
            setEditado(false);
            if( pacote.indexOf(classeName)< 0){
                setPacote( pacote+"."+classeName );
            }
            console.log('-->', pacote )
            postPacote(pacote);
        }
    }
    function postPacote(pk){
        pk = pk.replace(classeName, "");
        if( pk.charAt(pk.length-1) === '.'){
            pk = pk.substring(0, pk.length-1);
        }
        const dado = {
            pacote: pk
        };
        Service.POST("/api/security/pacote", dado ).then( r=>{
            console.log( r );
            if( action) action(pk);
            if( r.updatePacote === true){
                window.location.reload();
            }
        }).catch( er =>{
            console.log( er )
            if( er.status === 401){
                setTimeout(() => {
                    localStorage.setItem("page", window.location.pathname);
                    navigate("/login");    
                }, 2000);
                
            }
        })
    }
    
    function isValidJavaPackageName(packageName) {    
        console.log( packageName );    
        if (!packageRegex.test(packageName)) {
            setMsg("Pacote invalido! Falha no padrão");
            return false; // Fails basic regex pattern
        }
        // Split the package name into parts and check for reserved keywords
        const parts = packageName.split('.');
        for (const part of parts) {
          if (reservedKeywords.has(part.toLowerCase())) {
            setMsg("Pacote invalido! Palavra rersevada: "+part );
            return false; // Contains a reserved keyword as a part
          }
        }
      
        return true; // Valid package name
      }
     
    return (
        <div style={style}
        >
            <Stack direction="row" spacing={2} >
                <TextField fullWidth
                    id="id-pacote"
                    //onFocus={handleOnFocus}
                    //onBlur={handleLostFocus}
                    value={pacote||''} onChange={handleChangePacote}
                    label={label?label:null}
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Inventory2 />
                                </InputAdornment>
                            ),
                        },
                    }}
                    autoComplete="off"
                    variant={variant?variant:"standard"}
                    size="small"
                    helperText={msg}
                    error={msg.length > 1}
                />
                {editado && <React.Fragment>
                    {/* <Typography>.{classeName} </Typography> */}
                    <IconButton aria-label="salvar" color="primary" onClick={handleSalvaPacote}>
                        <Save />
                    </IconButton>
                </React.Fragment>}
            </Stack>
            <div style={{
                zIndex: 2,            
                position: 'absolute',
                // position: 'relative',
                top: '20px',
                // left: '20%',
                transform: 'translateX(-100%)'
            }}>
                {children && children}
            </div>
        </div>
    )
}